import { useState, useEffect } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";


const STORAGE_EXP = "alqos_ce_exportaciones";
const STORAGE_IMP = "alqos_ce_importaciones";
const STORAGE_CFG = "alqos_ce_config";
const STORAGE_CONTACTOS = "alqos_ce_contactos";
const STORAGE_ARANCELES = "alqos_ce_aranceles";

const TIPOS_CONTACTO = ["Despachante","Agente de carga","Banco operador","Aseguradora","Proveedor exterior","Cliente exterior","Otro"];

const storage = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k) || "[]"); } catch { return []; } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
};

const INCOTERMS = ["EXW","FCA","FOB","CIF","CFR","CPT","CIP","DAP","DDP"];
const DIVISAS = ["USD","EUR","BRL","GBP"];
const ESTADOS_EXP = {
  pedido:      { label: "📋 Pedido",       color: "#2A7FFF", bg: "#dbeafe" },
  produccion:  { label: "🏗️ Producción",   color: "#6B6FD6", bg: "#E8E9F6" },
  listo:       { label: "✅ Listo",         color: "#16a34a", bg: "#dcfce7" },
  embarque:    { label: "🚢 Embarcado",     color: "#0891b2", bg: "#cffafe" },
  cobrado:     { label: "💰 Cobrado",       color: "#15803d", bg: "#bbf7d0" },
  cancelado:   { label: "❌ Cancelado",     color: "#dc2626", bg: "#fee2e2" },
};
const ESTADOS_IMP = {
  orden:       { label: "📋 Orden emitida", color: "#2A7FFF", bg: "#dbeafe" },
  transito:    { label: "🚢 En tránsito",   color: "#0891b2", bg: "#cffafe" },
  aduana:      { label: "🏛️ En aduana",     color: "#d97706", bg: "#fef3c7" },
  deposito:    { label: "📦 En depósito",   color: "#6B6FD6", bg: "#E8E9F6" },
  nacionalizado:{ label: "✅ Nacionalizado", color: "#16a34a", bg: "#dcfce7" },
  cancelado:   { label: "❌ Cancelado",     color: "#dc2626", bg: "#fee2e2" },
};

function genCod(lista, pre) {
  return `${pre}-${new Date().getFullYear()}-${String(lista.length+1).padStart(4,"0")}`;
}
function hoy() { return new Date().toISOString().slice(0,10); }

export default function ComercioExterior({ onVolver, oscuro, usuario }) {
  const [seccion, setSeccion] = useState("exportaciones");
  const [exportaciones, setExportaciones] = useState(() => storage.get(STORAGE_EXP));
  const [importaciones, setImportaciones] = useState(() => storage.get(STORAGE_IMP));
  const [config, setConfig] = useState(() => { try { return JSON.parse(localStorage.getItem(STORAGE_CFG) || "{}"); } catch { return {}; } });
  const [vista, setVista] = useState("listado");
  const [detalle, setDetalle] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [contactos, setContactos] = useState(() => storage.get(STORAGE_CONTACTOS));
  const [aranceles, setAranceles] = useState(() => storage.get(STORAGE_ARANCELES));
  const [showContactoForm, setShowContactoForm] = useState(false);
  const [showArancelForm, setShowArancelForm] = useState(false);
  const [contactoForm, setContactoForm] = useState({});
  const [arancelForm, setArancelForm] = useState({});
  const [editContacto, setEditContacto] = useState(null);
  const [editArancel, setEditArancel] = useState(null);
  const [form, setForm] = useState({});
  const [confirmEliminar, setConfirmEliminar] = useState(null);

  const [ots, setOts] = useState([]);

  const esAdmin = usuario?.rol === "Administrador";

  useEffect(() => {

    try { setOts(JSON.parse(localStorage.getItem("alqos_ots") || "[]")); } catch {}
  }, []);

  const bg     = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto  = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde  = oscuro ? "#1e3a8a" : "#eee";
  const navBg  = oscuro ? "#060f30" : "#09184D";
  const sub    = oscuro ? "#9aabd4" : "#808085";

  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto, fontFamily:"sans-serif" };
  const lbl = { fontSize:"11px", color:sub, fontWeight:"700", display:"block", marginTop:"12px", textTransform:"uppercase", letterSpacing:".05em" };
  const card = { background:cardBg, borderRadius:"14px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"14px" };

  const guardarExp = () => {
    if (!form.cliente?.trim()) return alert("El cliente es obligatorio");
    if (!form.producto?.trim()) return alert("El producto es obligatorio");
    const nueva = {
      ...form,
      id: Date.now(),
      codigo: genCod(exportaciones, "EXP"),
      tipo: "exportacion",
      estado: "pedido",
      fechaCreacion: hoy(),
      creadoPor: usuario?.nombre || "Sistema",
      historialEstado: [],
    };
    const nuevas = [...exportaciones, nueva];
    setExportaciones(nuevas);
    storage.set(STORAGE_EXP, nuevas);
    subirDatos(STORAGE_EXP);
    setShowForm(false); setForm({});
  };

  const guardarImp = () => {
    if (!form.proveedor?.trim()) return alert("El proveedor es obligatorio");
    if (!form.producto?.trim()) return alert("El producto es obligatorio");
    const nueva = {
      ...form,
      id: Date.now(),
      codigo: genCod(importaciones, "IMP"),
      tipo: "importacion",
      estado: "orden",
      fechaCreacion: hoy(),
      creadoPor: usuario?.nombre || "Sistema",
      historialEstado: [],
    };
    const nuevas = [...importaciones, nueva];
    setImportaciones(nuevas);
    storage.set(STORAGE_IMP, nuevas);
    subirDatos(STORAGE_IMP);
    setShowForm(false); setForm({});
  };

  const cambiarEstadoExp = (id, nuevoEstado) => {
    const entrada = { estado: nuevoEstado, fecha: hoy(), usuario: usuario?.nombre };
    const lista = exportaciones.map(e => e.id===id ? { ...e, estado: nuevoEstado, historialEstado: [...(e.historialEstado||[]), entrada] } : e);
    setExportaciones(lista); storage.set(STORAGE_EXP, lista);
    subirDatos(STORAGE_EXP);
    if (detalle?.id===id) setDetalle(lista.find(e=>e.id===id));
  };

  const cambiarEstadoImp = (id, nuevoEstado) => {
    const entrada = { estado: nuevoEstado, fecha: hoy(), usuario: usuario?.nombre };
    const lista = importaciones.map(i => i.id===id ? { ...i, estado: nuevoEstado, historialEstado: [...(i.historialEstado||[]), entrada] } : i);
    setImportaciones(lista); storage.set(STORAGE_IMP, lista);
    subirDatos(STORAGE_IMP);
    if (detalle?.id===id) setDetalle(lista.find(i=>i.id===id));
    // Si se nacionaliza → vincular con Ingreso de Materiales
    if (nuevoEstado === "nacionalizado") {
      const ingresos = storage.get("alqos_ingreso_materiales");
      const imp = importaciones.find(i=>i.id===id);
      const nuevoIngreso = {
        id: Date.now(),
        codigoIngreso: `ING-IMP-${Date.now()}`,
        proveedor: imp?.proveedor || "",
        producto: imp?.producto || "",
        cantidad: imp?.cantidad || "",
        unidad: imp?.unidad || "",
        estado: "aprobado",
        origen: "importacion",
        codigoImportacion: imp?.codigo,
        fecha: hoy(),
        creadoPor: usuario?.nombre || "Sistema",
        _source: "localStorage",
      };
      storage.set("alqos_ingreso_materiales", [...ingresos, nuevoIngreso]);
      subirDatos("alqos_ingreso_materiales");
    }
  };

  const eliminarExp = async (id) => {
    const nuevas = exportaciones.filter(e => e.id !== id);
    setExportaciones(nuevas); storage.set(STORAGE_EXP, nuevas);
    await eliminarDato(STORAGE_EXP, id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const eliminarImp = async (id) => {
    const nuevas = importaciones.filter(i => i.id !== id);
    setImportaciones(nuevas); storage.set(STORAGE_IMP, nuevas);
    await eliminarDato(STORAGE_IMP, id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setC = (k, v) => setContactoForm(f => ({ ...f, [k]: v }));
  const setA = (k, v) => setArancelForm(f => ({ ...f, [k]: v }));

  const guardarContacto = () => {
    if (!contactoForm.nombre?.trim()) return alert("El nombre es obligatorio");
    if (editContacto) {
      const lista = contactos.map(c => c.id===editContacto ? { ...c, ...contactoForm } : c);
      setContactos(lista); storage.set(STORAGE_CONTACTOS, lista); subirDatos(STORAGE_CONTACTOS);
    } else {
      const nuevo = { ...contactoForm, id: Date.now(), fechaCreacion: hoy(), creadoPor: usuario?.nombre||"Sistema" };
      const lista = [...contactos, nuevo];
      setContactos(lista); storage.set(STORAGE_CONTACTOS, lista); subirDatos(STORAGE_CONTACTOS);
    }
    setShowContactoForm(false); setContactoForm({}); setEditContacto(null);
  };

  const eliminarContacto = async (id) => {
    if (!window.confirm("¿Eliminar este contacto?")) return;
    const lista = contactos.filter(c => c.id !== id);
    setContactos(lista); storage.set(STORAGE_CONTACTOS, lista);
    await eliminarDato(STORAGE_CONTACTOS, id);
  };

  const guardarArancel = () => {
    if (!arancelForm.ncm?.trim()) return alert("El NCM es obligatorio");
    if (editArancel) {
      const lista = aranceles.map(a => a.id===editArancel ? { ...a, ...arancelForm } : a);
      setAranceles(lista); storage.set(STORAGE_ARANCELES, lista); subirDatos(STORAGE_ARANCELES);
    } else {
      const nuevo = { ...arancelForm, id: Date.now(), fechaCreacion: hoy(), creadoPor: usuario?.nombre||"Sistema" };
      const lista = [...aranceles, nuevo];
      setAranceles(lista); storage.set(STORAGE_ARANCELES, lista); subirDatos(STORAGE_ARANCELES);
    }
    setShowArancelForm(false); setArancelForm({}); setEditArancel(null);
  };

  const eliminarArancel = async (id) => {
    if (!window.confirm("¿Eliminar esta posición arancelaria?")) return;
    const lista = aranceles.filter(a => a.id !== id);
    setAranceles(lista); storage.set(STORAGE_ARANCELES, lista);
    await eliminarDato(STORAGE_ARANCELES, id);
  };

  const kpis = {
    expActivas: exportaciones.filter(e => !["cobrado","cancelado"].includes(e.estado)).length,
    impActivas: importaciones.filter(i => !["nacionalizado","cancelado"].includes(i.estado)).length,
    expMes: exportaciones.filter(e => e.fechaCreacion?.startsWith(new Date().toISOString().slice(0,7))).length,
    impMes: importaciones.filter(i => i.fechaCreacion?.startsWith(new Date().toISOString().slice(0,7))).length,
  };

  // ── DETALLE EXPORTACIÓN ──
  if (vista === "detalle" && detalle?.tipo === "exportacion") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={() => { setDetalle(null); setVista("listado"); }} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{detalle.codigo}</span>
        </div>
        {esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"12px" }}>🗑 Eliminar</button>}
      </div>
      <div style={{ padding:"0 2rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ ...card, background:oscuro?"#0a1f5c":"#eff6ff", border:"1px solid #2A7FFF30" }}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#2A7FFF", marginBottom:"10px" }}>📋 Datos de exportación</h3>
          {[["Código",detalle.codigo],["Cliente",detalle.cliente],["País destino",detalle.paisDestino],["Producto",detalle.producto],["Cantidad",detalle.cantidad?`${detalle.cantidad} ${detalle.unidad||""}`:null],["Divisa",detalle.divisa],["Monto",detalle.monto?`${detalle.divisa||"USD"} ${Number(detalle.monto).toLocaleString("es-AR")}`:null],["Incoterm",detalle.incoterm],["OT vinculada",detalle.otVinculada],["Despachante",detalle.despachante],["Fecha embarque",detalle.fechaEmbarque],["Fecha cobro est.",detalle.fechaCobro],["Creado por",detalle.creadoPor]].map(([k,v]) => v && (
            <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", padding:"4px 0", borderBottom:`0.5px solid ${borde}` }}>
              <span style={{ color:sub }}>{k}</span>
              <span style={{ color:texto, fontWeight:"500" }}>{v}</span>
            </div>
          ))}
          {detalle.esFSC && <div style={{ marginTop:"8px", padding:"6px 12px", background:"#f0fdf4", border:"1px solid #22c55e", borderRadius:"8px", fontSize:"12px", color:"#15803d", fontWeight:"700" }}>🌿 Exportación con certificación FSC</div>}
        </div>
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#1C3FAA", marginBottom:"10px" }}>Estado</h3>
          <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
            {Object.entries(ESTADOS_EXP).map(([val,{label,color,bg:bg2}]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstadoExp(detalle.id, val)}
                style={{ padding:"7px 12px", borderRadius:"10px", fontSize:"12px", cursor:esAdmin?"pointer":"default", fontWeight:"600", border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:detalle.estado===val?bg2:cardBg, color:detalle.estado===val?color:sub }}>
                {label}
              </button>
            ))}
          </div>
          {(detalle.historialEstado||[]).length > 0 && (
            <div style={{ marginTop:"12px" }}>
              {[...detalle.historialEstado].reverse().map((h,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:"11px", padding:"4px 0", borderBottom:`0.5px solid ${borde}` }}>
                  <span style={{ color:ESTADOS_EXP[h.estado]?.color }}>{ESTADOS_EXP[h.estado]?.label}</span>
                  <span style={{ color:sub }}>{h.fecha} · {h.usuario}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        {detalle.observaciones && <div style={card}><p style={{ fontSize:"13px", color:texto }}>{detalle.observaciones}</p></div>}
      </div>
    </div>
  );

  // ── DETALLE IMPORTACIÓN ──
  if (vista === "detalle" && detalle?.tipo === "importacion") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={() => { setDetalle(null); setVista("listado"); }} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{detalle.codigo}</span>
        </div>
        {esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"12px" }}>🗑 Eliminar</button>}
      </div>
      <div style={{ padding:"0 2rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ ...card, background:oscuro?"#0a1f5c":"#fff8f0", border:"1px solid #f59e0b30" }}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#d97706", marginBottom:"10px" }}>📦 Datos de importación</h3>
          {[["Código",detalle.codigo],["Proveedor",detalle.proveedor],["País origen",detalle.paisOrigen],["Producto",detalle.producto],["Cantidad",detalle.cantidad?`${detalle.cantidad} ${detalle.unidad||""}`:null],["Divisa",detalle.divisa],["Monto FOB",detalle.montoFOB?`${detalle.divisa||"USD"} ${Number(detalle.montoFOB).toLocaleString("es-AR")}`:null],["Flete",detalle.flete?`USD ${Number(detalle.flete).toLocaleString("es-AR")}`:null],["Seguro",detalle.seguro?`USD ${Number(detalle.seguro).toLocaleString("es-AR")}`:null],["Aranceles",detalle.aranceles?`$${Number(detalle.aranceles).toLocaleString("es-AR")}`:null],["Honorarios desp.",detalle.honorarios?`$${Number(detalle.honorarios).toLocaleString("es-AR")}`:null],["Incoterm",detalle.incoterm],["Despachante",detalle.despachante],["ETA estimada",detalle.eta],["Creado por",detalle.creadoPor]].map(([k,v]) => v && (
            <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", padding:"4px 0", borderBottom:`0.5px solid ${borde}` }}>
              <span style={{ color:sub }}>{k}</span>
              <span style={{ color:texto, fontWeight:"500" }}>{v}</span>
            </div>
          ))}
          {detalle.estado === "nacionalizado" && <div style={{ marginTop:"8px", padding:"6px 12px", background:"#f0fdf4", border:"1px solid #22c55e", borderRadius:"8px", fontSize:"12px", color:"#15803d", fontWeight:"700" }}>✅ Ingreso de material generado automáticamente</div>}
        </div>
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#1C3FAA", marginBottom:"10px" }}>Estado</h3>
          <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
            {Object.entries(ESTADOS_IMP).map(([val,{label,color,bg:bg2}]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstadoImp(detalle.id, val)}
                style={{ padding:"7px 12px", borderRadius:"10px", fontSize:"12px", cursor:esAdmin?"pointer":"default", fontWeight:"600", border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:detalle.estado===val?bg2:cardBg, color:detalle.estado===val?color:sub }}>
                {label}
              </button>
            ))}
          </div>
          {(detalle.historialEstado||[]).length > 0 && (
            <div style={{ marginTop:"12px" }}>
              {[...detalle.historialEstado].reverse().map((h,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:"11px", padding:"4px 0", borderBottom:`0.5px solid ${borde}` }}>
                  <span style={{ color:ESTADOS_IMP[h.estado]?.color }}>{ESTADOS_IMP[h.estado]?.label}</span>
                  <span style={{ color:sub }}>{h.fecha} · {h.usuario}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // ── CONFIRM ELIMINAR ──
  if (confirmEliminar) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:cardBg, borderRadius:"16px", padding:"2rem", maxWidth:"360px", width:"90%", border:`1px solid ${borde}`, textAlign:"center" }}>
        <p style={{ fontSize:"32px" }}>🌐</p>
        <p style={{ fontSize:"15px", fontWeight:"600", color:texto, marginBottom:".5rem" }}>¿Eliminar esta operación?</p>
        <p style={{ fontSize:"13px", color:sub, marginBottom:"1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display:"flex", gap:"10px", justifyContent:"center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding:"10px 20px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto }}>Cancelar</button>
          <button onClick={() => seccion==="exportaciones" ? eliminarExp(confirmEliminar) : eliminarImp(confirmEliminar)}
            style={{ padding:"10px 20px", background:"#e63946", border:"none", borderRadius:"10px", cursor:"pointer", color:"white", fontWeight:"600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🌐 Comercio Exterior</span>
        </div>
        <button onClick={() => setShowForm(true)}
          style={{ padding:"6px 14px", background:"#2A7FFF", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
          + Nueva {seccion==="exportaciones"?"exportación":"importación"}
        </button>
      </div>

      {/* TABS */}
      <div style={{ display:"flex", borderBottom:`1px solid ${borde}`, background:cardBg, padding:"0 1.5rem" }}>
        {[["exportaciones","🚢 Exportaciones"],["importaciones","📦 Importaciones"],["config","⚙️ Configuración"]].map(([k,label]) => (
          <button key={k} onClick={() => setSeccion(k)}
            style={{ padding:"12px 18px", border:"none", borderBottom:seccion===k?`3px solid #2A7FFF`:"3px solid transparent", background:"none", cursor:"pointer", fontSize:"13px", fontWeight:seccion===k?"700":"500", color:seccion===k?"#2A7FFF":sub }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ padding:"1.2rem 1.5rem" }}>
        {/* KPIs */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"10px", marginBottom:"1.5rem" }}>
          {[["Exp. activas",kpis.expActivas,"#2A7FFF"],["Imp. activas",kpis.impActivas,"#d97706"],["Exp. este mes",kpis.expMes,"#16a34a"],["Imp. este mes",kpis.impMes,"#7B5BF2"]].map(([l,v,c]) => (
            <div key={l} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
              <div style={{ fontSize:"24px", fontWeight:"800", color:c }}>{v}</div>
              <div style={{ fontSize:"11px", color:sub, marginTop:"4px" }}>{l}</div>
            </div>
          ))}
        </div>

        {/* EXPORTACIONES */}
        {seccion === "exportaciones" && (
          exportaciones.length === 0
            ? <div style={{ textAlign:"center", padding:"5rem", color:sub }}><div style={{ fontSize:"48px" }}>🚢</div><p style={{ fontSize:"15px", fontWeight:"600", marginTop:"12px", color:texto }}>Sin exportaciones registradas</p></div>
            : [...exportaciones].reverse().map(e => {
                const est = ESTADOS_EXP[e.estado] || ESTADOS_EXP.pedido;
                return (
                  <div key={e.id} onClick={() => { setDetalle(e); setVista("detalle"); }}
                    style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"10px", cursor:"pointer" }}
                    onMouseEnter={x => x.currentTarget.style.boxShadow="0 4px 16px rgba(42,127,255,0.15)"}
                    onMouseLeave={x => x.currentTarget.style.boxShadow="none"}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <span style={{ fontWeight:"700", color:"#2A7FFF", fontSize:"13px" }}>{e.codigo}</span>
                        <span style={{ marginLeft:"10px", fontWeight:"600", fontSize:"13px", color:texto }}>{e.cliente}</span>
                        {e.esFSC && <span style={{ marginLeft:"6px", fontSize:"10px", color:"#15803d", background:"#dcfce7", padding:"1px 6px", borderRadius:"4px", fontWeight:"700" }}>🌿 FSC</span>}
                        <p style={{ fontSize:"12px", color:sub, margin:"4px 0 0" }}>{e.producto} · {e.paisDestino}</p>
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <span style={{ background:est.bg, color:est.color, fontSize:"11px", padding:"3px 9px", borderRadius:"20px", fontWeight:"600" }}>{est.label}</span>
                        {e.monto && <p style={{ fontSize:"11px", color:sub, margin:"4px 0 0" }}>{e.divisa||"USD"} {Number(e.monto).toLocaleString("es-AR")}</p>}
                      </div>
                    </div>
                    <div style={{ marginTop:"6px", fontSize:"11px", color:oscuro?"#2A7FFF":"#9b8cc4" }}>
                      {e.incoterm && `${e.incoterm} · `}{e.fechaCreacion} · {e.creadoPor}
                    </div>
                  </div>
                );
              })
        )}

        {/* IMPORTACIONES */}
        {seccion === "importaciones" && (
          importaciones.length === 0
            ? <div style={{ textAlign:"center", padding:"5rem", color:sub }}><div style={{ fontSize:"48px" }}>📦</div><p style={{ fontSize:"15px", fontWeight:"600", marginTop:"12px", color:texto }}>Sin importaciones registradas</p></div>
            : [...importaciones].reverse().map(i => {
                const est = ESTADOS_IMP[i.estado] || ESTADOS_IMP.orden;
                return (
                  <div key={i.id} onClick={() => { setDetalle(i); setVista("detalle"); }}
                    style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"10px", cursor:"pointer" }}
                    onMouseEnter={x => x.currentTarget.style.boxShadow="0 4px 16px rgba(217,119,6,0.15)"}
                    onMouseLeave={x => x.currentTarget.style.boxShadow="none"}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <span style={{ fontWeight:"700", color:"#d97706", fontSize:"13px" }}>{i.codigo}</span>
                        <span style={{ marginLeft:"10px", fontWeight:"600", fontSize:"13px", color:texto }}>{i.proveedor}</span>
                        <p style={{ fontSize:"12px", color:sub, margin:"4px 0 0" }}>{i.producto} · {i.paisOrigen}</p>
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <span style={{ background:est.bg, color:est.color, fontSize:"11px", padding:"3px 9px", borderRadius:"20px", fontWeight:"600" }}>{est.label}</span>
                        {i.montoFOB && <p style={{ fontSize:"11px", color:sub, margin:"4px 0 0" }}>{i.divisa||"USD"} {Number(i.montoFOB).toLocaleString("es-AR")}</p>}
                      </div>
                    </div>
                    <div style={{ marginTop:"6px", fontSize:"11px", color:oscuro?"#d97706":"#9b8cc4" }}>
                      {i.incoterm && `${i.incoterm} · `}ETA: {i.eta||"—"} · {i.creadoPor}
                    </div>
                  </div>
                );
              })
        )}

        {/* CONFIG */}
        {seccion === "config" && (<>
          {/* COTIZACIONES REFERENCIA */}
          <div style={card}>
            <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#1C3FAA", marginBottom:"12px" }}>💱 Cotizaciones de referencia</h3>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              {[["cotUSD","USD (dólar)"],["cotEUR","EUR (euro)"],["cotBRL","BRL (real)"],["cotGBP","GBP (libra)"]].map(([k,label]) => (
                <div key={k}>
                  <label style={lbl}>{label}</label>
                  <input type="number" value={config[k]||""} onChange={e => { const c={...config,[k]:e.target.value}; setConfig(c); localStorage.setItem(STORAGE_CFG, JSON.stringify(c)); }} style={inp} placeholder="$/divisa"/>
                </div>
              ))}
            </div>
          </div>

          {/* CONTACTOS */}
          <div style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px" }}>
              <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#1C3FAA", margin:0 }}>📋 Contactos de comercio exterior</h3>
              <button onClick={() => { setContactoForm({}); setEditContacto(null); setShowContactoForm(true); }}
                style={{ padding:"6px 14px", background:"#1C3FAA", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Agregar</button>
            </div>
            {contactos.length === 0
              ? <div style={{ textAlign:"center", padding:"2rem", color:sub, fontSize:"13px" }}>Sin contactos cargados</div>
              : contactos.map(c => (
                <div key={c.id} style={{ background:oscuro?"#091840":"#F9FAFB", borderRadius:"10px", padding:"12px 14px", marginBottom:"8px", border:`1px solid ${borde}` }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                      <div style={{ fontWeight:"700", fontSize:"13px", color:texto }}>{c.nombre}</div>
                      <div style={{ fontSize:"11px", color:"#2A7FFF", fontWeight:"600", marginTop:"2px" }}>{c.tipo}</div>
                      <div style={{ fontSize:"11px", color:sub, marginTop:"4px" }}>
                        {c.email && `📧 ${c.email}`}{c.telefono && ` · 📞 ${c.telefono}`}
                      </div>
                      {c.especialidad && <div style={{ fontSize:"11px", color:sub }}>{c.especialidad}</div>}
                      {c.cuit && <div style={{ fontSize:"11px", color:sub }}>CUIT: {c.cuit}</div>}
                    </div>
                    <div style={{ display:"flex", gap:"6px" }}>
                      <button onClick={() => { setContactoForm(c); setEditContacto(c.id); setShowContactoForm(true); }}
                        style={{ padding:"4px 10px", background:"#EFF6FF", border:"1px solid #93c5fd", color:"#1d4ed8", borderRadius:"6px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>✏️</button>
                      <button onClick={() => eliminarContacto(c.id)}
                        style={{ padding:"4px 10px", background:"#fee2e2", border:"1px solid #fca5a5", color:"#dc2626", borderRadius:"6px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>🗑</button>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>

          {/* ARANCELES */}
          <div style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px" }}>
              <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#1C3FAA", margin:0 }}>📊 Posiciones arancelarias frecuentes</h3>
              <button onClick={() => { setArancelForm({}); setEditArancel(null); setShowArancelForm(true); }}
                style={{ padding:"6px 14px", background:"#1C3FAA", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Agregar</button>
            </div>
            {aranceles.length === 0
              ? <div style={{ textAlign:"center", padding:"2rem", color:sub, fontSize:"13px" }}>Sin posiciones cargadas</div>
              : <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:oscuro?"#091840":"#F9FAFB" }}>
                      {["NCM","Descripción","Arancel %","Observaciones",""].map(h=>(
                        <th key={h} style={{ padding:"8px 12px", fontSize:"11px", fontWeight:"600", color:sub, textAlign:"left", borderBottom:`1px solid ${borde}` }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {aranceles.map(a=>(
                      <tr key={a.id} style={{ borderBottom:`1px solid ${borde}` }}>
                        <td style={{ padding:"8px 12px", fontSize:"12px", fontWeight:"700", color:"#1C3FAA" }}>{a.ncm}</td>
                        <td style={{ padding:"8px 12px", fontSize:"12px", color:texto }}>{a.descripcion}</td>
                        <td style={{ padding:"8px 12px", fontSize:"12px", fontWeight:"600", color:"#d97706" }}>{a.arancel}%</td>
                        <td style={{ padding:"8px 12px", fontSize:"11px", color:sub }}>{a.observaciones||"—"}</td>
                        <td style={{ padding:"8px 12px" }}>
                          <div style={{ display:"flex", gap:"4px" }}>
                            <button onClick={() => { setArancelForm(a); setEditArancel(a.id); setShowArancelForm(true); }}
                              style={{ padding:"3px 8px", background:"#EFF6FF", border:"1px solid #93c5fd", color:"#1d4ed8", borderRadius:"6px", cursor:"pointer", fontSize:"11px" }}>✏️</button>
                            <button onClick={() => eliminarArancel(a.id)}
                              style={{ padding:"3px 8px", background:"#fee2e2", border:"1px solid #fca5a5", color:"#dc2626", borderRadius:"6px", cursor:"pointer", fontSize:"11px" }}>🗑</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
            }
          </div>
        </>)}
      </div>

      {/* FORM NUEVA EXPORTACIÓN */}
      {showForm && seccion === "exportaciones" && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
          <div style={{ background:cardBg, borderRadius:"16px", width:"560px", maxHeight:"90vh", overflowY:"auto", padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#2A7FFF", margin:0 }}>🚢 Nueva exportación</h2>
              <button onClick={() => { setShowForm(false); setForm({}); }} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:sub }}>✕</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Cliente *</label>
                <input style={inp} value={form.cliente||""} onChange={e=>set("cliente",e.target.value)} placeholder="Nombre del cliente"/>
              </div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Producto *</label>
                <input style={inp} value={form.producto||""} onChange={e=>set("producto",e.target.value)} placeholder="Descripción del producto a exportar"/>
              </div>
              <div><label style={lbl}>País destino</label><input style={inp} value={form.paisDestino||""} onChange={e=>set("paisDestino",e.target.value)} placeholder="Ej: Brasil"/></div>
              <div><label style={lbl}>Incoterm</label>
                <select style={inp} value={form.incoterm||""} onChange={e=>set("incoterm",e.target.value)}>
                  <option value="">— Seleccionar —</option>
                  {INCOTERMS.map(i=><option key={i}>{i}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Divisa</label>
                <select style={inp} value={form.divisa||"USD"} onChange={e=>set("divisa",e.target.value)}>
                  {DIVISAS.map(d=><option key={d}>{d}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Monto</label><input type="number" style={inp} value={form.monto||""} onChange={e=>set("monto",e.target.value)}/></div>
              <div><label style={lbl}>Cantidad</label><input type="number" style={inp} value={form.cantidad||""} onChange={e=>set("cantidad",e.target.value)}/></div>
              <div><label style={lbl}>Unidad</label><input style={inp} value={form.unidad||""} onChange={e=>set("unidad",e.target.value)} placeholder="u., kg, resmas"/></div>
              <div><label style={lbl}>OT vinculada</label>
                <select style={inp} value={form.otVinculada||""} onChange={e=>set("otVinculada",e.target.value)}>
                  <option value="">— Sin vincular —</option>
                  {ots.map(o=><option key={o.op} value={o.op}>{o.op} · {o.cliente}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Despachante</label><input style={inp} value={form.despachante||config.despachante||""} onChange={e=>set("despachante",e.target.value)}/></div>
              <div><label style={lbl}>Fecha embarque</label><input type="date" style={inp} value={form.fechaEmbarque||""} onChange={e=>set("fechaEmbarque",e.target.value)}/></div>
              <div><label style={lbl}>Fecha cobro est.</label><input type="date" style={inp} value={form.fechaCobro||""} onChange={e=>set("fechaCobro",e.target.value)}/></div>
              <div style={{ gridColumn:"1/-1", display:"flex", alignItems:"center", gap:"10px", marginTop:"8px" }}>
                <input type="checkbox" id="esFSC" checked={form.esFSC||false} onChange={e=>set("esFSC",e.target.checked)} style={{ width:"16px", height:"16px" }}/>
                <label htmlFor="esFSC" style={{ fontSize:"13px", color:texto, cursor:"pointer" }}>🌿 Exportación con certificación FSC</label>
              </div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Observaciones</label><textarea rows={2} style={{ ...inp, resize:"none" }} value={form.observaciones||""} onChange={e=>set("observaciones",e.target.value)}/></div>
            </div>
            <div style={{ display:"flex", gap:"10px", marginTop:"20px" }}>
              <button onClick={() => { setShowForm(false); setForm({}); }} style={{ flex:1, padding:"10px", borderRadius:"10px", border:`1px solid ${borde}`, background:cardBg, fontSize:"13px", fontWeight:"600", cursor:"pointer", color:sub }}>Cancelar</button>
              <button onClick={guardarExp} style={{ flex:2, padding:"10px", borderRadius:"10px", border:"none", background:"#2A7FFF", color:"white", fontSize:"13px", fontWeight:"600", cursor:"pointer" }}>Guardar exportación</button>
            </div>
          </div>
        </div>
      )}

      {/* FORM NUEVA IMPORTACIÓN */}
      {showForm && seccion === "importaciones" && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
          <div style={{ background:cardBg, borderRadius:"16px", width:"560px", maxHeight:"90vh", overflowY:"auto", padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#d97706", margin:0 }}>📦 Nueva importación</h2>
              <button onClick={() => { setShowForm(false); setForm({}); }} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:sub }}>✕</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Proveedor *</label>
                <input style={inp} value={form.proveedor||""} onChange={e=>set("proveedor",e.target.value)} placeholder="Nombre del proveedor exterior"/>
              </div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Producto *</label>
                <input style={inp} value={form.producto||""} onChange={e=>set("producto",e.target.value)} placeholder="Ej: Cartulina SBS, Tinta UV"/>
              </div>
              <div><label style={lbl}>País origen</label><input style={inp} value={form.paisOrigen||""} onChange={e=>set("paisOrigen",e.target.value)} placeholder="Ej: Chile"/></div>
              <div><label style={lbl}>Incoterm</label>
                <select style={inp} value={form.incoterm||""} onChange={e=>set("incoterm",e.target.value)}>
                  <option value="">— Seleccionar —</option>
                  {INCOTERMS.map(i=><option key={i}>{i}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Divisa</label>
                <select style={inp} value={form.divisa||"USD"} onChange={e=>set("divisa",e.target.value)}>
                  {DIVISAS.map(d=><option key={d}>{d}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Monto FOB</label><input type="number" style={inp} value={form.montoFOB||""} onChange={e=>set("montoFOB",e.target.value)}/></div>
              <div><label style={lbl}>Cantidad</label><input type="number" style={inp} value={form.cantidad||""} onChange={e=>set("cantidad",e.target.value)}/></div>
              <div><label style={lbl}>Unidad</label><input style={inp} value={form.unidad||""} onChange={e=>set("unidad",e.target.value)} placeholder="kg, resmas, rollos"/></div>
              <div><label style={lbl}>Flete (USD)</label><input type="number" style={inp} value={form.flete||""} onChange={e=>set("flete",e.target.value)}/></div>
              <div><label style={lbl}>Seguro (USD)</label><input type="number" style={inp} value={form.seguro||""} onChange={e=>set("seguro",e.target.value)}/></div>
              <div><label style={lbl}>Aranceles ($)</label><input type="number" style={inp} value={form.aranceles||""} onChange={e=>set("aranceles",e.target.value)}/></div>
              <div><label style={lbl}>Honorarios desp. ($)</label><input type="number" style={inp} value={form.honorarios||""} onChange={e=>set("honorarios",e.target.value)}/></div>
              <div><label style={lbl}>Despachante</label><input style={inp} value={form.despachante||config.despachante||""} onChange={e=>set("despachante",e.target.value)}/></div>
              <div><label style={lbl}>ETA estimada</label><input type="date" style={inp} value={form.eta||""} onChange={e=>set("eta",e.target.value)}/></div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Observaciones</label><textarea rows={2} style={{ ...inp, resize:"none" }} value={form.observaciones||""} onChange={e=>set("observaciones",e.target.value)}/></div>
            </div>
            <div style={{ display:"flex", gap:"10px", marginTop:"20px" }}>
              <button onClick={() => { setShowForm(false); setForm({}); }} style={{ flex:1, padding:"10px", borderRadius:"10px", border:`1px solid ${borde}`, background:cardBg, fontSize:"13px", fontWeight:"600", cursor:"pointer", color:sub }}>Cancelar</button>
              <button onClick={guardarImp} style={{ flex:2, padding:"10px", borderRadius:"10px", border:"none", background:"#d97706", color:"white", fontSize:"13px", fontWeight:"600", cursor:"pointer" }}>Guardar importación</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CONTACTO */}
      {showContactoForm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
          <div style={{ background:cardBg, borderRadius:"16px", width:"500px", maxHeight:"90vh", overflowY:"auto", padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#1C3FAA", margin:0 }}>{editContacto?"✏️ Editar contacto":"📋 Nuevo contacto"}</h2>
              <button onClick={() => { setShowContactoForm(false); setContactoForm({}); setEditContacto(null); }} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:sub }}>✕</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              <div style={{ gridColumn:"1/-1" }}>
                <label style={lbl}>Nombre / Razón social *</label>
                <input style={inp} value={contactoForm.nombre||""} onChange={e=>setC("nombre",e.target.value)} placeholder="Ej: Aduanera del Sur SA"/>
              </div>
              <div>
                <label style={lbl}>Tipo</label>
                <select style={inp} value={contactoForm.tipo||""} onChange={e=>setC("tipo",e.target.value)}>
                  <option value="">— Seleccionar —</option>
                  {TIPOS_CONTACTO.map(t=><option key={t}>{t}</option>)}
                </select>
              </div>
              <div><label style={lbl}>CUIT</label><input style={inp} value={contactoForm.cuit||""} onChange={e=>setC("cuit",e.target.value)} placeholder="XX-XXXXXXXX-X"/></div>
              <div><label style={lbl}>Contacto principal</label><input style={inp} value={contactoForm.contacto||""} onChange={e=>setC("contacto",e.target.value)}/></div>
              <div><label style={lbl}>Email</label><input type="email" style={inp} value={contactoForm.email||""} onChange={e=>setC("email",e.target.value)}/></div>
              <div><label style={lbl}>Teléfono</label><input style={inp} value={contactoForm.telefono||""} onChange={e=>setC("telefono",e.target.value)}/></div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Especialidad / Rutas habituales</label><input style={inp} value={contactoForm.especialidad||""} onChange={e=>setC("especialidad",e.target.value)} placeholder="Ej: Importación desde Asia, exportación Mercosur"/></div>
              <div><label style={lbl}>País</label><input style={inp} value={contactoForm.pais||""} onChange={e=>setC("pais",e.target.value)}/></div>
              <div><label style={lbl}>Matrícula / Registro</label><input style={inp} value={contactoForm.matricula||""} onChange={e=>setC("matricula",e.target.value)}/></div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Observaciones</label><textarea rows={2} style={{ ...inp, resize:"none" }} value={contactoForm.observaciones||""} onChange={e=>setC("observaciones",e.target.value)}/></div>
            </div>
            <div style={{ display:"flex", gap:"10px", marginTop:"20px" }}>
              <button onClick={() => { setShowContactoForm(false); setContactoForm({}); setEditContacto(null); }} style={{ flex:1, padding:"10px", borderRadius:"10px", border:`1px solid ${borde}`, background:cardBg, fontSize:"13px", fontWeight:"600", cursor:"pointer", color:sub }}>Cancelar</button>
              <button onClick={guardarContacto} style={{ flex:2, padding:"10px", borderRadius:"10px", border:"none", background:"#1C3FAA", color:"white", fontSize:"13px", fontWeight:"600", cursor:"pointer" }}>💾 Guardar contacto</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL ARANCEL */}
      {showArancelForm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
          <div style={{ background:cardBg, borderRadius:"16px", width:"480px", maxHeight:"90vh", overflowY:"auto", padding:"24px", boxShadow:"0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#1C3FAA", margin:0 }}>{editArancel?"✏️ Editar posición":"📊 Nueva posición arancelaria"}</h2>
              <button onClick={() => { setShowArancelForm(false); setArancelForm({}); setEditArancel(null); }} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:sub }}>✕</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              <div><label style={lbl}>NCM *</label><input style={inp} value={arancelForm.ncm||""} onChange={e=>setA("ncm",e.target.value)} placeholder="Ej: 4819.10.00"/></div>
              <div><label style={lbl}>Arancel %</label><input type="number" style={inp} value={arancelForm.arancel||""} onChange={e=>setA("arancel",e.target.value)} placeholder="Ej: 14"/></div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Descripción</label><input style={inp} value={arancelForm.descripcion||""} onChange={e=>setA("descripcion",e.target.value)} placeholder="Ej: Cajas y estuches de papel o cartón"/></div>
              <div><label style={lbl}>IVA %</label><input type="number" style={inp} value={arancelForm.iva||""} onChange={e=>setA("iva",e.target.value)} placeholder="21"/></div>
              <div><label style={lbl}>Tasa estadística %</label><input type="number" style={inp} value={arancelForm.tasaEst||""} onChange={e=>setA("tasaEst",e.target.value)} placeholder="0.5"/></div>
              <div style={{ gridColumn:"1/-1" }}><label style={lbl}>Observaciones</label><textarea rows={2} style={{ ...inp, resize:"none" }} value={arancelForm.observaciones||""} onChange={e=>setA("observaciones",e.target.value)} placeholder="Ej: Aplica para importaciones desde fuera del Mercosur"/></div>
            </div>
            <div style={{ display:"flex", gap:"10px", marginTop:"20px" }}>
              <button onClick={() => { setShowArancelForm(false); setArancelForm({}); setEditArancel(null); }} style={{ flex:1, padding:"10px", borderRadius:"10px", border:`1px solid ${borde}`, background:cardBg, fontSize:"13px", fontWeight:"600", cursor:"pointer", color:sub }}>Cancelar</button>
              <button onClick={guardarArancel} style={{ flex:2, padding:"10px", borderRadius:"10px", border:"none", background:"#1C3FAA", color:"white", fontSize:"13px", fontWeight:"600", cursor:"pointer" }}>💾 Guardar posición</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
// This line intentionally left blank
